import React from "react";
import "./index.less";

const Label = ({ children, style, className }) => {
  return (
    <div className={`onyx-label ${className ? className : ""}`} style={style}>
      {children}
    </div>
  );
};

export default Label;
